import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-right-more",
  "use": "icon-icon-right-more-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-icon-right-more\">\n<style type=\"text/css\">\n\t#icon-icon-right-more .st0{opacity:0.8;}\n\t#icon-icon-right-more .st1{fill:#FFFFFF;fill-opacity:0;}\n\t#icon-icon-right-more .st2{fill:#FFFFFF;}\n</style>\n<g transform=\"translate(-1722 -25)\" class=\"st0\">\n\t<rect x=\"1722\" y=\"25\" class=\"st1\" width=\"20\" height=\"20\" />\n\t<path class=\"st2\" d=\"M1729.1,41.8l6.4-5.9c0.2-0.2,0.3-0.6,0-0.8l0,0l-6.4-5.9c-0.3-0.2-0.7-0.2-0.9,0c-0.1,0.1-0.2,0.2-0.2,0.4\n\t\tv11.8c0,0.3,0.3,0.6,0.7,0.6C1728.8,42,1729,41.9,1729.1,41.8z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-right-more.svg
// module id = jiVY
// module chunks = 28